import OrderProgressStatus from "../../../../components/NewDetail/Order";

const NewOrderDetail = () => {
  return <OrderProgressStatus />;
};
export default NewOrderDetail;
